import { TerminalNodeInterpreter } from "./TerminalNodeInterpreter";
import { IScoredTerminalNode, IStableTerminalNode, ITerminalNode, ITerminalScore, IUnstableTerminalNode } from "./TerminalScore";

export class TerminalScoreManager {
    constructor(public score: ITerminalScore) {}


    get scoredNodeIds(): string[] {
        return Object.keys(this.score.scored);
    }

    get scoredNodes(): IScoredTerminalNode[] {
        const scored = this.scoredNodeIds.map(key => this.score.scored[key]);
        return scored;
    }

    get stableNodeIds(): string[] {
        return Object.keys(this.score.stable);
    }

    get stableNodes(): IStableTerminalNode[] {
        return this.stableNodeIds.map(key => this.score.stable[key]);
    }

    get unstableNodeIds(): string[] {
        return Object.keys(this.score.unstable);
    }

    get unstableNodes(): IUnstableTerminalNode[] {
        return this.unstableNodeIds.map(key => this.score.unstable[key]);
    }

    get allNodes(): ITerminalNode[] {
        return [
            ...this.scoredNodes,
            ...this.stableNodes,
            ...this.unstableNodes
        ];
    }


    get allNodeIds(): string[] {
        return [
            ...this.scoredNodeIds,
            ...this.stableNodeIds,
            ...this.unstableNodeIds
        ];
    }



    getNodeStatus(nodeId:string): "scored"|"unstable"|"stable"|undefined {
        if (this.scoredNodeIds.includes(nodeId)) {
            return 'scored';
        }
        if (this.stableNodeIds.includes(nodeId)) {
            return 'stable';
        }
        if (this.unstableNodeIds.includes(nodeId)) {
            return 'unstable';
        }
        return undefined;
    }

    getNodeRank(nodeId:string): number {
        const scored = this.scoredNodes;
        scored.sort((a,b) => b.centrality - a.centrality); // Centrality 2nd order
        scored.sort((a,b) => b.score - a.score); // Score 1st order
        const node = this.getNode(nodeId);
        const index = scored.indexOf(node as IScoredTerminalNode);
        if (index < 0) {
            return -1;
        } else {
            return index + 1;
        }
        
    }

    getNode(nodeId:string): ITerminalNode {
        const status = this.getNodeStatus(nodeId);
        if (status === 'scored') {
            return this.score.scored[nodeId];
        } else if (status === 'stable') {
            return this.score.stable[nodeId];
        } else if (status === 'unstable') {
            return this.score.unstable[nodeId];
        }
        return undefined;
    }

    getCentralityPercentile(nodeId: string): number {
        const node = this.getNode(nodeId);
        const allNodes = [...this.stableNodes, ...this.scoredNodes];
        allNodes.sort((a,b) => a.centrality_normalized - b.centrality_normalized);

        const rank = allNodes.indexOf(node as any);
        const percentile = Math.floor((rank/allNodes.length)*100);
        if (percentile >=0) {
            return percentile;
        } else {
            return 0;
        }
    }

    get goodPeers(): string[] {
        const goodPeerIds = new Set<string>()
        this.scoredNodes.forEach(n => {
          const interpreter = new TerminalNodeInterpreter(n);
          for (const peer of interpreter.goodPeers) {
              goodPeerIds.add(peer);
          }
        })
        return Array.from(goodPeerIds);
    }

    

}